@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.tooltip {
  position: fixed;
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 20%) 0 5px 10px;
  width: fit-content;

  &.top {
    transform: translate(-50%, -100%);
    max-width: 300px;
    margin-top: -15px;
  }

  &.top-left {
    transform: translate(0, -100%);
    max-width: 300px;
    margin-top: -15px;

    .tooltip-arrow {
      left: 5px;
      transform: none;
    }
  }

  &.top-right {
    transform: translate(-100%, -100%);
    max-width: 300px;
    margin-top: -15px;
    margin-right: -15px;

    .tooltip-arrow {
      left: initial;
      right: 5px;
      transform: none;
    }
  }

  &.bottom {
    transform: translate(-50%, 0);
    max-width: 300px;
    margin-top: 15px;
  }

  &.bottom-left {
    transform: none;
    max-width: 300px;
    margin-top: 15px;

    .tooltip-arrow {
      left: 5px;
      transform: none;
    }
  }

  &.bottom-right {
    transform: translate(-100%, 0);
    max-width: 300px;
    margin-top: 15px;
    margin-right: -15px;

    .tooltip-arrow {
      left: initial;
      right: 5px;
      transform: none;
    }
  }

  &.right {
    margin-left: 15px;
    transform: translate(0, -50%);
  }

  &.right-top {
    margin-left: 15px;
    transform: none;

    .tooltip-arrow {
      top: 5px;
      transform: none;
    }
  }

  &.right-bottom {
    margin-left: 15px;
    transform: translate(0, -100%);

    .tooltip-arrow {
      top: initial;
      bottom: 5px;
      transform: none;
    }
  }

  &.left {
    margin-left: -15px;
    transform: translate(-100%, -50%);
  }

  &.left-top {
    margin-left: -15px;
    transform: translate(-100%, 0);

    .tooltip-arrow {
      top: 5px;
      transform: none;
    }
  }

  &.left-bottom {
    margin-left: -15px;
    transform: translate(-100%, -100%);

    .tooltip-arrow {
      top: initial;
      bottom: 5px;
      transform: none;
    }
  }
}

.tooltip-content {
  display: block;
  position: relative;
  max-width: 300px;
}

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  z-index: 99999999;

  &.down {
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid var(--grey-300);
    &.dark {
      border-top: 10px solid var(--tooltip--background-color);
    }
  }

  &.right {
    top: 50%;
    left: 100%;
    transform: translateY(-50%);
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid var(--grey-300);
    &.dark {
      border-left: 10px solid var(--tooltip--background-color);
    }
  }

  &.up {
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid var(--grey-300);
    &.dark {
      border-bottom: 10px solid var(--tooltip--background-color);
    }
  }

  &.left {
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid var(--red-600);
    &.dark {
      border-right: 10px solid var(--tooltip--background-color);
    }
  }
}
